// Static content (non-editable)
export const BRAND = {
  name: "Hitha Residency",
  tagline: "Service Apartment",
  phone: "8792597381",
  whatsapp: "918792597381",
  address: {
    line1: "No.11, Vinayaka Layout, Buddha Jyothi Attached,",
    line2: "Near Prestige Jindal Behind Road,",
    line3: "Tumkur Road, Chikkbidrekallu,",
    line4: "Bangalore - 560073",
  },
  mapsQuery: "13.053222,77.491194",
};

export const MARQUEE_ITEMS = [
  { lang: "en", text: "Atithi Devo Bhava", italic: true },
  { lang: "hi", text: "अतिथिदेवो भव" },
  { lang: "kn", text: "ಅತಿಥಿ ದೇವೋ ಭವ" },
  { lang: "ta", text: "அதிதி தேவோ பவா" },
  { lang: "te", text: "అతిథి దేవో భవ" },
  { lang: "ml", text: "അതിഥി ദേവോ ഭവ" },
];

// Real property photos uploaded by owner
export const HERO_IMAGES = [
  { url: "/property/building-front.jpg", label: "Building Front" },
  { url: "/property/hall-living.jpg", label: "Living Room" },
  { url: "/property/hall-2.jpg", label: "Hall" },
];

export const PROPERTY_GALLERY = [
  { url: "/property/building-front.jpg", label: "Building Front", category: "exterior" },
  { url: "/property/visitor-lobby.jpg", label: "Visitor Lobby", category: "common" },
  { url: "/property/3bhk-living.jpg", label: "3 BHK Living Room", category: "interior" },
  { url: "/property/3bhk-room5.jpg", label: "3 BHK Bedroom", category: "interior" },
  { url: "/property/3bhk-room6.jpg", label: "3 BHK Second Bedroom", category: "interior" },
  { url: "/property/3bhk-room8.jpg", label: "3 BHK Master Suite", category: "interior" },
  { url: "/property/room-8.jpg", label: "1 BHK Large", category: "interior" },
  { url: "/property/1bhk-compact-main.jpg", label: "1 BHK Compact — Bedroom", category: "interior" },
  { url: "/property/1bhk-compact-living.jpg", label: "1 BHK Compact — Living Room", category: "interior" },
  { url: "/property/1bhk-compact-tv.jpg", label: "1 BHK Compact — TV Unit", category: "interior" },
  { url: "/property/single-ac-main.jpg", label: "Single Master A/C Room", category: "interior" },
  { url: "/property/single-ac-wide.jpg", label: "Single Master A/C — Bed & TV", category: "interior" },
  { url: "/property/single-ac-room.jpg", label: "Single Master A/C — Room Overview", category: "interior" },
  { url: "/property/room-6.jpg", label: "Cozy Bedroom", category: "interior" },
  { url: "/property/2bhk-main.jpg", label: "2 BHK — Living Room & TV", category: "interior" },
  { url: "/property/2bhk-living.jpg", label: "2 BHK — Lounge Sofa", category: "interior" },
  { url: "/property/2bhk-bedroom1.jpg", label: "2 BHK — Master Bedroom", category: "interior" },
  { url: "/property/2bhk-bedroom2.jpg", label: "2 BHK — Second Bedroom", category: "interior" },
  { url: "/property/inside-1.jpg", label: "Inside View", category: "interior" },
  { url: "/property/kitchen-3.jpg", label: "Kitchen", category: "amenity" },
  { url: "/property/kitchen-5.jpg", label: "Modular Kitchen", category: "amenity" },
  { url: "/property/lobby.jpg", label: "Lobby Entrance", category: "common" },
  { url: "/property/building-side.jpg", label: "Building Side", category: "exterior" },
  { url: "/property/bathroom.jpg", label: "Bathroom", category: "amenity" },
  { url: "/property/safety-lock.jpg", label: "Safety Lock", category: "amenity" },
];

export const DISTANCES = [
  {
    key: "chikka-metro",
    icon: "Train",
    km: "550m",
    name: "Chikkabidarakallu",
    sub: "Metro Station (Green Line)",
    maps: "Chikkabidarakallu+Metro+Station+Bangalore",
  },
  {
    key: "naga-metro",
    icon: "Train",
    km: "~2",
    name: "Nagasandra",
    sub: "Metro Station (Green Line)",
    maps: "Nagasandra+Metro+Station+Bangalore",
  },
  {
    key: "biec",
    icon: "Building2",
    km: "~2",
    name: "BIEC",
    sub: "Exhibition Centre",
    maps: "BIEC+Bangalore+International+Exhibition+Centre",
  },
  {
    key: "majestic",
    icon: "Bus",
    km: "~11",
    name: "Majestic",
    sub: "Bus Stand / Metro Hub",
    maps: "Majestic+Bus+Stand+Bangalore",
  },
  {
    key: "airport",
    icon: "Plane",
    km: "~35",
    name: "Kempegowda",
    sub: "International Airport",
    maps: "Kempegowda+International+Airport+Bangalore",
  },
];

// Map each room key to a property image (real photos)
export const ROOM_IMAGES = {
  "single-nonac": "/property/room-6.jpg",
  "single-ac": "/property/single-ac-main.jpg",
  "1bhk-compact": "/property/1bhk-compact-main.jpg",
  "1bhk-large": "/property/room-8.jpg",
  "2bhk": "/property/2bhk-main.jpg",
  "3bhk": "/property/3bhk-living.jpg",
};

export const FACILITIES = [
  { icon: "Sofa", name: "Fully Furnished", desc: "Premium furniture, move-in ready" },
  { icon: "Wifi", name: "WiFi & Smart TV", desc: "High-speed internet & streaming" },
  { icon: "ChefHat", name: "Kitchen & Appliances", desc: "Fridge, microwave & essentials" },
  { icon: "Car", name: "Parking Facility", desc: "Dedicated secure parking" },
  { icon: "ShieldCheck", name: "24/7 Security", desc: "CCTV & round-the-clock guard" },
  { icon: "Sparkles", name: "Housekeeping", desc: "Regular professional cleaning" },
  { icon: "Shirt", name: "Laundry Service", desc: "In-house laundry, hassle-free" },
  { icon: "CarTaxiFront", name: "Taxi on Call", desc: "One-call cab anytime you need" },
  { icon: "Stethoscope", name: "Doctor on Call", desc: "Medical assistance on request" },
  { icon: "UtensilsCrossed", name: "Food Discounts", desc: "Special rates at partner restaurants" },
];

export const METRO_STATIONS = [
  {
    name: "Chikkabidarakallu",
    line: "Green Line",
    distance: "550 m · ~7 min walk",
    note: "Opened Nov 2024",
  },
  {
    name: "Nagasandra",
    line: "Green Line",
    distance: "~2 km · 5 min by auto",
    note: "",
  },
];

export const WHY_CHOOSE = [
  "Just 2 km from BIEC Exhibition Centre — perfect for events & expos",
  "Quick access to NICE Road exit — drive to Mysore in 2.5 hours",
  "Tucked into a peaceful residential layout — no horns, no traffic noise",
  "Calm, family-friendly environment ideal for relaxed sleep",
  "Just 550 m from Chikkabidarakallu Namma Metro (Green Line)",
  "Daily & Monthly rentals — A/C and Non-A/C options to suit every budget",
  "Doctor on call & taxi assistance available 24/7",
  "Special food discounts at partner restaurants nearby",
];

// Bangalore attractions — landmarks for the "Explore Bengaluru" collage
// Verified Wikimedia Commons URLs (public domain)
export const BANGALORE_ATTRACTIONS = [
  {
    name: "Vidhana Soudha",
    subtitle: "Seat of Karnataka State Legislature",
    distance: "~18 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/2/25/Vidhana_Soudha_2012.jpg",
    maps: "Vidhana+Soudha+Bangalore",
    tag: "Landmark",
  },
  {
    name: "Bangalore Palace",
    subtitle: "Tudor-style royal palace",
    distance: "~14 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/8/8f/Bangalore_Mysore_Maharaja_Palace.jpg",
    maps: "Bangalore+Palace",
    tag: "Heritage",
  },
  {
    name: "High Court of Karnataka",
    subtitle: "Red-brick Attara Kacheri",
    distance: "~17 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/High_Court_of_Karnataka_building%2C_February_2017_03.jpg/1280px-High_Court_of_Karnataka_building%2C_February_2017_03.jpg",
    maps: "High+Court+of+Karnataka+Bangalore",
    tag: "Landmark",
  },
  {
    name: "Ulsoor Lake",
    subtitle: "Serene 50-acre lake & boating",
    distance: "~20 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/5/5d/Ulsoor_lake_Bangalore_India.jpg",
    maps: "Ulsoor+Lake+Bangalore",
    tag: "Nature",
  },
  {
    name: "Wonderla Amusement Park",
    subtitle: "Thrill rides & water park",
    distance: "~38 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Wonderla_entrance_bangalore_26122014.jpg/1280px-Wonderla_entrance_bangalore_26122014.jpg",
    maps: "Wonderla+Bangalore",
    tag: "Entertainment",
  },
  {
    name: "Cubbon Park",
    subtitle: "300-acre green lung of the city",
    distance: "~16 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Cubbon_Park_W.jpg",
    maps: "Cubbon+Park+Bangalore",
    tag: "Nature",
  },
  {
    name: "Lalbagh Botanical Garden",
    subtitle: "Iconic glasshouse & flora",
    distance: "~19 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Glasshouse_and_fountain_at_lalbagh.jpg",
    maps: "Lalbagh+Botanical+Garden+Bangalore",
    tag: "Nature",
  },
  {
    name: "ISKCON Temple",
    subtitle: "Majestic Krishna temple",
    distance: "~6 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/1/11/ISKCON_Banglaore_Temple.jpg",
    maps: "ISKCON+Temple+Bangalore",
    tag: "Spiritual",
  },
  {
    name: "Orion Mall",
    subtitle: "Premium shopping & dining hub",
    distance: "~8 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/0/09/Interior_of_Orion_Mall_Bangalore%2C_June_2016.jpg",
    maps: "Orion+Mall+Brigade+Gateway+Bangalore",
    tag: "Shopping",
  },
  {
    name: "Mantri Square Mall",
    subtitle: "Largest mall in Bangalore",
    distance: "~9 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Mantri_Square%2C_Malleshwaram%2C_Bangalore_%282025%29_04.jpg",
    maps: "Mantri+Square+Mall+Bangalore",
    tag: "Shopping",
  },
  {
    name: "VR Mall",
    subtitle: "Retail & entertainment complex",
    distance: "~12 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/3/34/VR_Bengaluru_Facade.jpg",
    maps: "VR+Mall+Bangalore",
    tag: "Shopping",
  },
  {
    name: "Mysore Palace",
    subtitle: "Royal palace & heritage icon",
    distance: "~145 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Mysore_Palace_Morning.jpg",
    maps: "Mysore+Palace+Mysore",
    tag: "Day Trip",
  },
  {
    name: "Mysore Zoo",
    subtitle: "One of India's oldest & finest zoos",
    distance: "~145 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/6/63/Entrance_of_Mysore_Zoo.jpg",
    maps: "Mysore+Zoo+Mysore",
    tag: "Day Trip",
  },
  {
    name: "Nandi Hills",
    subtitle: "Scenic sunrise hilltop retreat",
    distance: "~60 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/d/d2/Nandi_Hills_Sunrise.jpg",
    maps: "Nandi+Hills+Chikkaballapur+Karnataka",
    tag: "Nature",
  },
  {
    name: "Hampi",
    subtitle: "UNESCO World Heritage ruins",
    distance: "~350 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/7/76/A_view_of_Hampi.jpg",
    maps: "Hampi+Karnataka",
    tag: "Heritage",
  },
  {
    name: "Isha Foundation",
    subtitle: "Adiyogi — spiritual landmark",
    distance: "~40 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/1/1e/Adiyogi_Shiva_steel_burst_2018.jpg",
    maps: "Isha+Foundation+Bangalore",
    tag: "Spiritual",
  },
  {
    name: "Hogenakkal Falls",
    subtitle: "The 'Niagara of India'",
    distance: "~180 km",
    url: "https://upload.wikimedia.org/wikipedia/commons/5/52/Hogenakkal_Falls_Close.jpg",
    maps: "Hogenakkal+Falls+Tamil+Nadu",
    tag: "Nature",
  },
];
